// extracted by mini-css-extract-plugin
export default {"app":"App_app__6Ra7L","canvas":"App_canvas__w7-D1","animation":"App_animation__ScdsQ","hand":"App_hand__ihk9E","pulseUp":"App_pulseUp__CId3c"};